<template>
  <div class="lp-radio-container" :style="rcStyle">
    <div class="lp-radio-group" v-for="(item,idx) in data" :key="'lp-radio'+idx" :style="groupStyle">
      <div style="display: flex; align-items: center;">
        <div class="lp-radio-button-group">
          <div :class="{ 'lp-radio-outer' : item.value===selectedVal, 'lp-radio-outer-none': item.value!==selectedVal }"
               @click="clickRadio(idx)">
            <div v-if="item.value===selectedVal" class="lp-radio-inner"></div>
          </div>
        </div>
        <div class="lp-radio-label" :style="labelStyle(item.value)" @click="clickRadio(idx)">{{ item.label }}</div>
        <!-- 인풋과 세트인 경우 -->
        <div v-if="showInput===true" style="padding:0 10px;display:flex">
          <div class="control">
            <input class="input"
                   :placeholder="item.num"
                   :value="item.num"
                   @keyup="res=> $emit('onEdit', {value: item.value, text:res})"
                   type="text"
                   :disabled="item.value!==selectedVal"
                   v-if="showInput===true">
          </div>

          <!--<lp-input-text :placeholder="item.num" :data.sync="item.num" @onKeyup="res => $emit('onEdit', {value: item.value, text:res})"
                        :disabled="item.value!==selectedVal"
                        :inputWidth="childInputWidth" v-if="showInput===true"></lp-input-text>-->
          <div v-if="item.unit!==undefined" style="margin:auto 4px;color:#555;font-size:0.9rem">{{ item.unit }}</div>
        </div>
      </div>
      <!-- 설명이 있는 경우 -->
      <div v-if="item.detail" class="lp-radio-detail" :style="detailStyle">{{ item.detail }}</div>
      <div>
        <div v-if="item.value===0" style="padding: 5px">
          <span class="lp-grade-label lp-label-represent-border-text">일반회원</span></div>
        <div v-else-if="item.value===1" style="padding: 5px">
          <span class="lp-grade-label lp-label-represent-text">일반회원</span></div>
        <div v-else-if="item.value===2" style="padding: 5px">
          <span class="lp-grade-label lp-label-represent-icon-text">
            <i class="material-icons" style="vertical-align: middle">person_outline</i>
            일반회원</span>
        </div>
        <div v-else-if="item.value===3" style="padding: 5px">
          <span class="lp-grade-label lp-label-represent-circle-label-text">일반회원</span></div>
        <div v-else-if="item.value===4" style="padding: 5px">
          <span class="lp-grade-label lp-label-represent-square-label-text">일반회원</span></div>
      </div>
    </div>
  </div>
</template>

<script>
  import LpInputText from '../common/LpInputText'
  export default {
    props: ['data', 'val', 'type', 'showInput', 'groupMargin', 'groupWidth', 'raInputWidth', 'detailStyle', 'block'],
    components: {
      LpInputText
    },
    data() {
      return {
        list: [],
        selectedVal: '',
        childInputWidth: ''
      }
    },
    created() {
      this.list = this.data;

      if ( this.val !== undefined ) {
        this.selectedVal = this.val;
      }

      if ( this.raInputWidth !== undefined ) {
        this.childInputWidth = this.raInputWidth;
      }
      else {
        this.childInputWidth = '90px';
      }

    },
    computed: {
      groupStyle() {
        let style = {};

        if ( this.block !== undefined ) {
          style.display = this.block;
        }
        if ( this.groupMargin !== undefined ) {
          style.margin = this.groupMargin;
        }
        if ( this.groupWidth !== undefined ) {
          style.width = this.groupWidth;
        }


        return style;
      },
      rcStyle() {
        let style = {};
        if ( this.block !== undefined ) {
          style.display = 'block';
        }
        return style;
      }
    },
    watch: {
      val(n) {
        if(n !== undefined)
          this.selectedVal = n;
      },
      data(n) {
        this.list = this.data;
      }
    },
    methods: {
      clickRadio(index) {
        this.selectedVal = this.data[index].value;
        this.$emit('onSelect', this.selectedVal);
        this.$emit('update:val', this.data[index].value);
      },
      labelStyle(value) {
        if ( this.type == 'brandFont' ) {
          let style = {};
          style.fontFamily = value;
          return style;
        }
        if ( this.type === 'small' ) {
          return 'font-size: .83rem; margin-left: 4px;';
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_variable'

  .lp-radio-group
    //display inline-flex
    //align-items center
    //flex-wrap wrap
    display inline-block
    text-align center
    margin-right 20px

  // 셀렉트 여부 상관없이
  // 레이블 밀리지 않도록 크기 고정
  .lp-radio-button-group
    width 20px
    height 20px
    display flex
    align-items center
    justify-content center

  .lp-radio-outer
    background $primary
    width 18px
    height 18px
    display inline-flex
    justify-content center
    align-items center
    border-radius 18px
    cursor pointer

  .lp-radio-outer-none
    background-color #fff
    border 1px solid #dbdbdb
    width 16px
    height 16px
    display inline-flex
    justify-content center
    align-items center
    border-radius 16px
    cursor pointer

  .lp-radio-inner
    background-color #fff
    width 10px
    height 10px
    border-radius 10px
    cursor pointer

  .lp-radio-label
    font-size 0.9rem
    color #333333
    display inline-block
    margin-left 8px
    cursor pointer

  .lp-radio-detail
    font-size 0.8rem
    color #989898
    margin-left 28px

  .lp-grade-label
    padding 2px 8px
    font-size 0.8rem

  .lp-label-represent-border-text
    border 1px solid $primary
    padding 2px 8px
    border-radius 16px
    color $primary

  .lp-label-represent-text
    color $primary

  .lp-label-represent-icon-text
    color $primary
  .lp-label-represent-circle-label-text
    background-color $primary
    border-radius 6px
    color white
  .lp-label-represent-square-label-text
    background-color $primary
    color white
</style>
